import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

interface UseGetQualityChecklistItemListProps {
  checklistId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getQualityChecklistItemList = async (checklistId: string) => {
  return await axiosAuth.get(`${QUALITY_CHECKLIST_API}/${checklistId}/items`);
};

const useGetQualityChecklistItemList = ({
  checklistId,
  queryParams,
}: UseGetQualityChecklistItemListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["quality-checklist-item", checklistId],
    queryFn: () => getQualityChecklistItemList(checklistId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetQualityChecklistItemList;
